import {getRandomColor} from "../../../utils/GetRandomColor";
import nnSvg from "../../../assets/img/blog/mathematicalArtificialIntelligence/nnsvg.png"
import treeSvg from "../../../assets/img/blog/mathematicalArtificialIntelligence/treesvg.png"
import {MathJax, MathJaxContext} from "better-react-mathjax";


export default function DiscreteMathematics() {
    const imgStyle = {
        backgroundColor: "#E9E8E6",
        border: `5px solid ${getRandomColor()}`,
    }

    const altTextStyle = {
        marginLeft: "auto",
        marginRight: "auto",
        display: "block",
        textAlign: "center",
        marginTop: "-10px",
        fontStyle: "italic",
    }

    const mathJaxConfig = {
        loader: {load: ["[tex]/html"]},
        tex: {
            packages: {"[+]": ["html"]},
            inlineMath: [["$", "$"], ["\\(", "\\)"]],
            displayMath: [["$$", "$$"], ["\\[", "\\]"]]
        }
    }

    return (
        <div className={"blog-body"}>
            <h2>Discrete Mathematics</h2>
            <p>
                The computers we use in our daily lives are digital, and digital computers are known to
                perform calculations on discrete systems (The Editors of Encyclopaedia Britannica, 2020),
                so it is no wonder that discrete mathematics is a part of computer programming, hence
                machine learning.
            </p>

            <h3>Graph Theory</h3>
            <p>
                One way to visualize the relationships between entities is to use graphs. Graph theory is
                often used to represent neural networks (Figure 11) and decision trees (Figure 12).
            </p>

            <img className={"blog-img"} style={imgStyle} src={nnSvg}
                 alt="neural networks"/>
            <div style={altTextStyle}><b>Figure 11:</b> An artificial neural network.</div>


            <img className={"blog-img"} style={imgStyle} src={treeSvg}
                 alt="decision tree"/>
            <div style={altTextStyle}><b>Figure 12:</b> A decision tree.</div>

            <h3>Time Complexity</h3>
            <p>
                In computer science, one way to measure the efficiency of an algorithm is to calculate its
                time complexity. The running speed of algorithms strongly affects the training time, since
                machine learning is an iterative process.
            </p><p>
            Using the numbers n for the training examples, d for the dimensions, and k for the
            neighbours, the training time complexities of some machine learning algorithms are given
            as (Kumar, 2021).
        </p>
            <MathJaxContext config={mathJaxConfig}>
                <ul>
                    <li><b>K nearest neighbors:</b> <MathJax inline>{"$O(knd)$"}</MathJax></li>
                    <li><b>Logistic regression:</b> <MathJax inline>{"$O(nd)$"}</MathJax></li>
                    <li><b>Decision tree:</b> <MathJax inline>{"$O(n\\log(n)d)$"}</MathJax></li>
                    <li><b>Random forest:</b> <MathJax inline>{"$O(n\\log(n)dk)$"}</MathJax></li>
                </ul>
            </MathJaxContext>
        </div>
    )
}